import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';

export const ContactBoxLink = styled.a<{ $isPhonesVisible: boolean }>`
  position: relative;
  height: 54px;
  padding-left: 47px;
  border-radius: 14px;
  border: solid 1px ${({ theme }) => theme.colors.systemColors.blue};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & + & {
    margin-top: 10px;
  }

  ${({ $isPhonesVisible }) =>
    $isPhonesVisible &&
    css`
      border: none;
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    `}

  &::before {
    content: '';
    position: absolute;
    height: 17px;
    width: 17px;
    top: 50%;
    left: 20px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    transform: translateY(-50%);
    background-image: url('/static/images/phone_call_blue-icon.svg');
  }

  &::after {
    background-image: url('/static/images/item/arrow-right.svg');
    content: '';
    width: 10px;
    height: 17px;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
    margin: auto;
  }
`;

export const ContactLinkText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
`;
